import {DateUtilities} from '@shared/utilities/date-utilities.model';

export class OrderDetails {
	cod_typ_order_state: string;
	cod_typ_state: string;
	id_order: number;
	id_deliverypoint: string;
	id_version: number;
	id_check: number;
	txt_vehicle: string;
	date_order: string;
	txt_chassis: string;
	txt_plate: string;
	date_transfer_expected: string;
	date_transferred: string;
	date_ready: string;
	date_ready_sp: string;
	date_invoice: string;
	flag_custom_delivery: boolean;
	flag_winter_tyres: boolean;
	flag_alarm: boolean;
	flag_satellite_alarm: boolean;
	flag_fuelcard_delivery: boolean;
	flag_save_enabled: boolean;
	flag_ready_enabled: boolean;
	flag_suspend_enabled: boolean;
	flag_fastdelivery: boolean;
	flag_specialsetup: boolean;
	date_customermessage: string;

	txt_tyre_summer_category: string;
	txt_tyre_winter_category: string;

	val_months: any;
	val_km: number;
	cod_veh_type: string;
	id_typ_purchase: string;

	date_request: string;
	id_order_replace: string;
	txt_plate_return: string;
	txt_exchange_plate?: string;

	flag_reallocated?: string;
	val_priority: string;
	flag_priority_forced: boolean;
	txt_labels: string;

	txt_insurance_notes: string;
	txt_insurance_number: string;
	date_insurance_expiration: string;
	can_update_insurance_details: boolean;
	flag_insurance_delivery: string;

	constructor(model?: any) {
		if (model) {
			this.id_deliverypoint = model.id_deliverypoint;
			if (model.cod_typ_order_state) {
				this.cod_typ_order_state = model.cod_typ_order_state;
			}
			if (model.cod_typ_state) {
				this.cod_typ_state = model.cod_typ_state;
			}
			if (model.id_order) {
				this.id_order = model.id_order;
			}
			if (model.id_check) {
				this.id_check = Number.parseInt(model.id_check);
			}
			if (model.id_version) {
				this.id_version = model.id_version;
			}
			if (model.txt_vehicle) {
				this.txt_vehicle = model.txt_vehicle;
			}
			if (model.txt_chassis) {
				this.txt_chassis = model.txt_chassis;
			}
			if (model.txt_plate) {
				this.txt_plate = model.txt_plate;
			}
			if (model.date_invoice) {
				this.date_invoice = model.date_invoice;
			}
			if (model.date_order) {
				this.date_order = (model.date_order.substring(0, model.date_order.indexOf(' ')));
			}
			if (model.date_transfer_expected) {
				this.date_transfer_expected = (model.date_transfer_expected.substring(0, model.date_transfer_expected.indexOf(' ')));
			}
			if (model.date_ready_sp) {
				this.date_ready_sp = model.date_ready_sp;
			}
			if (model.date_transferred) {
				this.date_transferred = (model.date_transferred.substring(0, model.date_transferred.indexOf(' ')));
			}
			if (model.date_ready) {
				this.date_ready = (model.date_ready.substring(0, model.date_ready.indexOf(' ')));
			}
			if (model.date_customermessage) {
				this.date_customermessage = (model.date_customermessage.substring(0, model.date_customermessage.indexOf(' ')));
			}
			this.flag_custom_delivery = (model.flag_custom_delivery) === '1';
			this.flag_alarm = (model.flag_alarm) === '1';
			this.flag_fuelcard_delivery = (model.flag_fuelcard_delivery) === '1';
			this.flag_satellite_alarm = (model.flag_satellite_alarm) === '1';
			this.flag_winter_tyres = (model.flag_winter_tyres) === '1';
			this.flag_suspend_enabled = (model.flag_suspend_enabled) === 1;
			this.flag_save_enabled = (model.flag_save_enabled) === 1;
			this.flag_ready_enabled = (model.flag_ready_enabled) === 1;
			this.flag_fastdelivery = (model.flag_fastdelivery) === 1;
			this.flag_specialsetup = (model.flag_specialsetup) === '1';
			if (model.txt_tyre_summer_category) {
				this.txt_tyre_summer_category = model.txt_tyre_summer_category;
			}
			if (model.txt_tyre_winter_category) {
				this.txt_tyre_winter_category = model.txt_tyre_winter_category;
			}
			this.val_months = model.val_months;
			if (!isNaN(model.val_km)) {
				this.val_km = model.val_km;
			}
			this.cod_veh_type = model.cod_veh_type;
			this.id_typ_purchase = model.id_typ_purchase;

			if (model.date_request) {
				this.date_request = model.date_request;
			}

			this.id_order_replace = model.id_order_replace;
			this.txt_plate_return = model.txt_plate_return;
			this.txt_exchange_plate = model.txt_exchange_plate;
			this.flag_reallocated = model.flag_reallocated;
			this.val_priority = model.val_priority;
			this.flag_priority_forced = model.flag_priority_forced;
			this.txt_labels = model.txt_labels;
			this.date_insurance_expiration = model.date_insurance_expiration;
			this.txt_insurance_number = model.txt_insurance_number;
			this.txt_insurance_notes = model.txt_insurance_notes;
			this.can_update_insurance_details = model.can_update_insurance_details;
			this.flag_insurance_delivery = model.flag_insurance_delivery;
		}
	}

	getDateTransferred(): Date | null {
		return DateUtilities.getDateFromString(this.date_transferred, DateUtilities.onlyDate);
	}
}
